
    <template>
    <svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
	<path fill="currentColor"
		d="M544 805.888V168a32 32 0 1 0-64 0v637.888L246.656 557.952a30.72 30.72 0 0 0-45.312 0 35.52 35.52 0 0 0 0 48.064l288 306.048a30.72 30.72 0 0 0 45.312 0l288-306.048a35.52 35.52 0 0 0 0-48 30.72 30.72 0 0 0-45.312 0L544 805.824z">
	</path>
</svg>
    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'Bottom',
    }) as DefineComponent
    </script>
    